import { supabase } from './supabaseClient';

// Sign up function and insert user into 'users' table
export const signUp = async (email, password) => {
  const emailRedirectTo =
    typeof window !== 'undefined'
      ? `${window.location.origin}/select-plan`
      : '/select-plan';

  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      emailRedirectTo,
    },
  });

  if (error) {
    throw error;
  }

  const user = data.user;

  return { user, session: data.session };
};

// Log in function (for email/password)
export const logIn = async (email, password) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
  
    if (error) {
      throw error;
    }
  
    const user = data.user;
  
    // Retrieve additional user data from the 'users' table
    const { data: userData, error: fetchError } = await supabase
      .from('users')
      .select('*')
      .eq('id', user.id)
      .single(); // Ensures we expect a single row
  
    if (fetchError) {
    throw fetchError;
    } else {
    }
  
    return { user, userData };
  };

// Google Sign-In function
export const signInWithGoogle = async () => {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
  });

  if (error) {
    throw error;
  }
};
